import './location.scss';
import 'assets/scripts/infobox';
import 'assets/scripts/maps';
import AOS from 'aos';

export default () => {
	$( '.maps' ).maps( {
		map: {
			disableDefaultUI: true,
			zoomControl: true,
		},
		infobox: {
			closeBoxMargin: '-15px -15px 0px 0px',
			closeBoxURL: 'https://www.google.com/intl/en_us/mapfiles/close.gif',
		},
	} );

	let input = document.getElementById( 'search' );

	let options = {
		types: [ 'geocode' ],
		componentRestrictions: {
			country: 'nl',
		},
		strictBounds: false,
	};
	let searchBox = new google.maps.places.Autocomplete( input, options );

	searchBox.addListener( 'place_changed', function () {
		let place = searchBox.getPlace();

		if ( !place.geometry ) {
			return;
		}
		let bounds = new google.maps.LatLngBounds();

		  // Get the latitude and longitude of the selected place
		var lat = place.geometry.location.lat();
		var lng = place.geometry.location.lng();
		var latLng = new google.maps.LatLng(lat, lng);

		bounds.extend( latLng );

		// Manipulate an existing map object
		$( '.maps' ).zoom_in( bounds );
	} );

	AOS.init( {
		duration: 800,
		once: true,
	} );

};
